import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=ba30fa0e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba30fa0e')) {
      api.createRecord('ba30fa0e', component.options)
    } else {
      api.reload('ba30fa0e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=ba30fa0e&", function () {
      api.rerender('ba30fa0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dLm6smQxWhd8/JS/comp/ImgFallback.vue"
export default component.exports